import { render } from "./IreCommonStreetsEditing.vue?vue&type=template&id=ddf467c0&ts=true"
import script from "./IreCommonStreetsEditing.vue?vue&type=script&lang=ts"
export * from "./IreCommonStreetsEditing.vue?vue&type=script&lang=ts"

import "./IreCommonStreetsEditing.vue?vue&type=style&index=0&id=ddf467c0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__